export default __webpack_public_path__ + "static/media/5.32c127bb.jpg";